import Skeleton from '@mui/material/Skeleton';
import classNames from 'classnames';
import { CLASSNAME } from '../utils/constants';

interface RewardsListSkeletonProps {
  className?: string;
}

export function RewardsListSkeleton({ className }: RewardsListSkeletonProps) {
  return (
    <div
      className={classNames(CLASSNAME, className, 'qlf-scrollable__overflow', 'qlf-skeleton')}
      role="status"
      style={{ flexGrow: 1 }}
      aria-live="polite"
      // not translated as this is backend rendered and while we have the locale at hand, it's not handy to make i18next work with SSR
      aria-label="Loading rewards"
    >
      <div className={classNames('qlf-list-wrapper', `${CLASSNAME}-wrapper`)}>
        <ul className={classNames('qlf-list', CLASSNAME)}>
          {Array.from({ length: 3 }).map((_, index) => (
            <li key={index} className={`${CLASSNAME}__item`}>
              <Skeleton
                variant="circular"
                width="4rem"
                height="4rem"
                style={{ marginRight: '20px' }}
              />
              <div className={`${CLASSNAME}__item-body`}>
                <div className={`${CLASSNAME}__text-wrapper`}>
                  <Skeleton
                    variant="text"
                    width="12rem"
                    height="1.5rem"
                    style={{ marginBottom: '0.5rem' }}
                  />
                  <Skeleton variant="text" width="16rem" height="1rem" />
                  <Skeleton
                    variant="text"
                    width="8rem"
                    height="1rem"
                    style={{ marginTop: '0.25rem' }}
                  />
                </div>
                <div className={`${CLASSNAME}__reward`}>
                  <div className={`${CLASSNAME}__currency`}>
                    <Skeleton
                      variant="text"
                      width="3rem"
                      height="1.25rem"
                      style={{ marginRight: '0.5rem' }}
                    />
                    <Skeleton variant="circular" width="1.5rem" height="1.5rem" />
                  </div>
                  <Skeleton
                    variant="rectangular"
                    width="6rem"
                    height="2rem"
                    style={{ marginTop: '0.5rem', borderRadius: '0.25rem' }}
                  />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
